import React, { Component } from 'react'
import {FormattedMessage} from 'react-intl';
import QRGenerator from "./QRGenerator";
import ConfigBusiness from "../../commons/config/ConfigBusiness.js";

class QR extends Component {
    constructor(props) {
        super(props);
        const token = ConfigBusiness.get('reportarIncidentes.tokenUrl');
        this.urlReporte = `${window.location.origin}/reporte-formulario/${token}`;
        const tokenSafeFeedback = ConfigBusiness.get('reportarIncidentes.tokenUrl');
        this.urlSafeFeedback = `${window.location.origin}/safefeedback-formulario/${tokenSafeFeedback}`;
    }
    render() {
        return (
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-md-6 col-12 mb-2">
                        <h3 className="content-header-title"><FormattedMessage id="ReportarIncidente.Administracion_de_QR" defaultMessage="Administración de QR"/></h3>
                    </div>
                </div>
                <div className="content-body">
                    {ConfigBusiness.get("reportarIncidentes.habilitado") === "true" &&  ConfigBusiness.get("safefeedback.habilitado") === "true" ?
                        <QRGenerator url={this.urlReporte} />
                    : ''}
                </div>
                {ConfigBusiness.get("safefeedback.activarNuevosComponentes") === "true" ?
                    <>
                        <div className="content-header row">
                            <div className="content-header-left col-md-6 col-12 mb-2">
                                <h3 className="content-header-title"><FormattedMessage id="ReportarIncidente.Administracion_de_QR_test" defaultMessage="Administración de QR Test"/></h3>
                            </div>
                        </div>
                        <div className="content-body">
                            <QRGenerator url={this.urlSafeFeedback} />
                        </div>
                    </>
                : ''}
            </div>
        );
    }
}

export default QR;